import React, { Component } from 'react';
import type { Store } from 'redux';
import isEmpty from 'lodash/isEmpty';
import AppBase from '@atlassian/jira-app-base/src/index.tsx';
import AppStyle from '@atlassian/jira-common-components-app-style/src/index.tsx';
import isShallowEqual from '@atlassian/jira-common-util-is-shallow-equal/src/index.tsx';
import { FlagsDispatcher } from '@atlassian/jira-flags';
import flagsMapper from './flags/index.tsx';
import { APP_ID } from './model/constants.tsx';
import { rootOperation } from './ops/index.tsx';
import { fetchAvatars, initializeAppProps } from './state/actions.tsx';
import createStore from './state/index.tsx';
import { getAvatars } from './state/selectors.tsx';
import type { State, Props } from './state/types.tsx';
import View from './view/index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { Avatar } from './model/types';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { Props } from './state/types';

// eslint-disable-next-line jira/react/no-class-components
export default class AvatarModal extends Component<Props> {
	constructor(props: Props) {
		super(props);
		this.store = createStore(rootOperation, props);
		this.store.dispatch(fetchAvatars());
	}

	componentDidUpdate(prevProps: Props) {
		const avatars = getAvatars(this.store.getState());
		if (isShallowEqual(prevProps, this.props)) {
			return;
		}

		this.store.dispatch(initializeAppProps(this.props));

		if (!prevProps.isOpen && this.props.isOpen) {
			this.store.dispatch(fetchAvatars());
		}

		if (!isEmpty(avatars) && !this.props.selectedAvatar) {
			this.props.onAvatarSelected(avatars[0]);
		}
	}

	store: Store<State>;

	render() {
		return (
			<AppBase id={APP_ID} store={this.store}>
				<AppStyle>
					<FlagsDispatcher mapper={flagsMapper} />
					<View />
				</AppStyle>
			</AppBase>
		);
	}
}
